import { collectionDocument } from "@/core-nextv3/document/document.api";
import { CASINO_SETTING } from "@/setting/setting";

export async function getCasinoLobbies() {
	const result = await collectionDocument(
		CASINO_SETTING.merge({
			perPage: 100,
			orderBy: "order",
			asc: true,
			where: [
				{
					field: "_level",
					operator: "==",
					value: 2,
				},
				{
					field: "type.value",
					operator: "==",
					value: "lobby",
				},
			],
		}),
	);

	if (result?.collection) {
		result?.collection.forEach((item: any) => {
			item.name = item.name.replaceAll("_", " ");
		});
	}

	return result?.collection || [];
}
